<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm8>
                <v-text-field
                  label="部门名称"
                  :rules="rules.normal"
                  v-model="item.name"/>
              </v-flex>

              <v-flex xs12 sm2>
                <v-text-field
                  label="部门简称"
                  :rules="rules.normal"
                  v-model="item.abbreviation"/>
              </v-flex>

              <v-flex xs12 sm2>
                <v-select
                  label="禁用"
                  v-model="item.disabled"
                  :items="[{value: true, text:'是'},{value: false, text:'否'}]"
                  :rules="rules.binary"
                />
              </v-flex>

              <v-flex xs12 sm8>
                <v-autocomplete
                  label="上级管理部门"
                  item-text="name"
                  item-value="dbid"
                  autocomplete
                  clearable
                  :loading="parentLoading"
                  :items="parentItems"
                  :search-input.sync="parentSearch"
                  v-model="item.parentId"
                  v-on:keyup.enter="onParentSearch"
                  @click:append="onParentSearch"
                  hint="输入关键词检索"
                  persistent-hint
                />
              </v-flex>

              <v-flex xs12 sm2>
                <v-text-field
                  label="排序"
                  :rules="rules.rank"
                  v-model="item.rank"/>
              </v-flex>

              <v-flex xs12 sm2>
                <v-select
                  label="科研管理部门"
                  v-model="item.isAdmin"
                  :items="[{value: true, text:'是'},{value: false, text:'否'}]"
                  :rules="rules.binary"
                />
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                  label="拥有的角色"
                  item-text="name"
                  item-value="dbid"
                  autocomplete
                  clearable
                  multiple
                  :loading="roleLoading"
                  :items="roleItems"
                  :search-input.sync="roleSearch"
                  v-model="item.roleIds"
                  v-on:keyup.enter="onRoleSearch"
                  @click:append="onRoleSearch"
                  hint="输入关键词检索"
                  persistent-hint
                  required
                  :rules="rules.required"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field label="备注" v-model="item.note"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/syst/department';
  const roleUri = '/api/syst/role';

  export default {
    mixins: [mixin.edit(baseUri)],
    data() {
      return {
        formValid: false,

        item: {},
        freshItem: {
          "parentId": null,
          "name": null,
          "disabled": null,
          "note": null,

          "roleIds": []
        },

        /**
         * 验证规则
         */
        rules: {
          required: [
            v => !!v || '必填项。'
          ],

          binary: [
            v => (v === true || v === false) || '必填项。'
          ],

          rank: [
            v => !!v || '必填项。',
            v => (v && /^\d+$/.test(v)) || '只能填写数字。'
          ],
          normal: [v => (v && v.length <= 50) || '长度必须小于50个字符。']
        },

        parentLoading: false,
        parentItems: [],
        parentSearch: '',

        roleLoading: false,
        roleItems: [],
        roleSearch: ''
      }
    },

    methods: {
      // mixin 加载数据后调用
      afterGetData(data) {
        this.parentItems = data.parent ? [data.parent] : [];
        this.roleItems = data.roles || [];

        data.roleIds = data.roles.map(r => r.dbid);
      },

      // 类别下拉框
      onParentSearch() {
        const vm = this;
        const param = window.xutil.param("name", this.parentSearch);
        param["sort"] = "name.asc";

        vm.parentLoading = true;
        this.axios.get(baseUri, {params: param})
          .then(
            rsp => {
              vm.parentLoading = false;
              vm.parentItems = rsp.data.items
            })
      },

      // 角色下拉框
      onRoleSearch() {
        const vm = this;
        const param = window.xutil.param("name", this.roleSearch);
        param["sort"] = "name.asc";

        vm.roleLoading = true;
        this.axios.get(roleUri, {params: param})
          .then(
            rsp => {
              vm.roleLoading = false;
              vm.roleItems = rsp.data.items
            })
      }
    }
  }
</script>
